import { addDate, getUnixTimeStamp, isBeforeDate } from '@orion/fe-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function readCacheItem<T>(key: string): T {
    let cacheItem = null;

    try {
        const storedItem = JSON.parse(window.localStorage.getItem(key));

        if (storedItem?.exp && !isBeforeDate(storedItem.exp, new Date())) {
            cacheItem = storedItem.data;
        }
    } catch (err) {
        // TODO: Handle error properly — left empty to preserve legacy behavior
    }

    return cacheItem;
}

export function writeCacheItem<T>(key: string, value: T, { amount, unit }): void {
    let cacheItem = JSON.stringify(value);

    if (amount || unit) {
        cacheItem = JSON.stringify({
            data: value,
            exp: getUnixTimeStamp(addDate(amount, unit)),
        });
    }

    window.localStorage.setItem(key, cacheItem);
}
